export default __webpack_public_path__ + "static/media/calender.b54707c1.svg";